import {
  Button,
  Icon,
  Input,
  Spin,
  Table,
  Row,
  Upload,
  Dropdown,
  Menu,
  Popconfirm,
  Empty,
} from "antd";
import React, { Fragment } from "react";
import Highlighter from "react-highlight-words";
import "../../components/general/drawer/AdaptiveDrawer.css";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { FileService } from "../../services/file/FileService";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import "./PromptsTable.css";
import { showSuccessToast } from "../general/ToastHelper";
import { convertTZToLocal } from "../general/DateTzHelper";
import CreateCallFlow from "../callFlowCreation/CreateCallFlow";
import history from "../../utils/history";

import i18next from "i18next";
class CallFlowsTable extends React.Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("callFlowConfig");
    this.fileService = new FileService();
    this.state = {
      isFetching: false,
      searchText: "",
      file: null,
      uploading: false,
      data: [],
      edit: false,
      callFlowData: null,
      recordData: null,
    };
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={i18next.t(`Search`) + i18next.t(`${dataIndex}`)}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={
            this.props.context.curr_dir === "ltr" &&
            this.props.context.curr_lang === "en"
              ? { width: 100, marginRight: 8 }
              : { width: 100, marginLeft: 8 }
          }
        >
          {i18next.t("Search")}
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 80 }}
        >
          {i18next.t("Reset")}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: "#d73a31" }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] != null &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text}
      />
    ),
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  componentDidMount() {
    this.getAllCallFlows();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }
  async getAllCallFlows() {
    try {
      this.setState({ isFetching: true });
      let data = await this.fileService.getCallFlowsService(
        this.props.context.session_id
      );

      this.setState({ data: this.formatData(data), isFetching: false });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  formatData(data) {
    const updated_data = [];
    for (var i = 0; i < data.ivrList.length; i++) {
      var row = {};
      row["key"] = i + 1;
      row["name"] = data.ivrList[i]["name"];
      row["createdOn"] = convertTZToLocal(data.ivrList[i]["createdOn"]);
      row["fileId"] = data.ivrList[i]["fileId"];
      updated_data.push(row);
    }
    return updated_data;
  }
  hanndleCancel = () => {
    this.setState({
      file: null,
      uploading: false,
    });
  };

  handleUpload = async () => {
    this.setState({
      uploading: true,
    });

    let session_id = this.props.context.session_id;

    try {
      let response = await this.fileService.uploadCallFlow(
        session_id,
        this.state.file
      );
      this.setState({
        file: null,
        uploading: false,
      });
      showSuccessToast(i18next.t("uploaded successfully"));
      this.getAllCallFlows();
    } catch (e) {
      this.setState({
        uploading: false,
      });
      handleError(e);
    }
  };
  itemRender = (current, type, originalElement) => {
    if (type === "prev") {
      return (
        <a className="ant-pagination-item-link">
          <Icon
            type={this.props.context.curr_dir === "rtl" ? "right" : "left"}
          />
        </a>
      );
    }
    if (type === "next") {
      return (
        <a className="ant-pagination-item-link">
          <Icon
            type={this.props.context.curr_dir === "rtl" ? "left" : "right"}
          />
        </a>
      );
    }
    return originalElement;
  };

  async handleDownload(record) {
    let session_id = this.props.context.session_id;
    try {
      let response = await this.fileService.downloadCallFlow(
        session_id,
        record
      );
      let result = await response.text();
      this.setState({ recordData: record });
      this.setState({ callFlowData: result });
      this.setState({ edit: true });

      // const reader = new FileReader();
      // reader.addEventListener("loadend", (e) => {
      //   const text = e.srcElement.result;
      //   this.setState({ callFlowData: text });

      // });
      // reader.readAsText(response);
      // return response;
    } catch (e) {
      handleError(e);
    }
  }

  renderActionDropdown(record) {
    const menu = (
      <Menu>
        <Menu.Item>
          <Popconfirm
            title={i18next.t("Are you sure delete this CallFlow?")}
            onConfirm={() => this.deleteRecord(record)}
            okText={i18next.t("Yes")}
            cancelText={i18next.t("No")}
          >
            <a href="#" style={{ color: "rgba(0, 0, 0, 0.65)" }}>
              {i18next.t("Delete")}
              <Icon className={"delete-account-style"} type="delete" />
            </a>
          </Popconfirm>
        </Menu.Item>
        <Menu.Item
          onClick={() => {
            this.handleDownload(record);
            // this.setState({ callFlowData: this.handleDownload(record) });
          }}
        >
          <span>{i18next.t("Edit")}</span>
          <Icon className={"view-details-style"} type="edit" />
        </Menu.Item>

        {/* <Menu.Item onClick={() => this.handleDownload(record)}>
          <span>Download</span>
          <Icon className={"view-details-style"} type="download" />
        </Menu.Item> */}
      </Menu>
    );
    return (
      <Dropdown overlay={menu}>
        <Button size="small" style={{ borderWidth: 0 }}>
          <Icon item={record} type="more" />
        </Button>
      </Dropdown>
    );
  }

  async deleteRecord(record) {
    try {
      let data = await this.fileService.deleteCallFlow(
        this.props.context.session_id,
        record
      );
      showSuccessToast(i18next.t("Callflow deleted successfully"));
      this.handleRefresh();
    } catch (e) {
      handleError(e);
    }
  }

  handleRefresh() {
    this.getAllCallFlows();
  }

  addNewFlow = () => {
    history.push("/home/configuration/createCallFlow");
  };

  render() {
    const columns = [
      {
        title: i18next.t("Name"),
        dataIndex: "name",
        key: "name",
        width: "30%",
        ...this.getColumnSearchProps("name"),
      },
      {
        title: i18next.t("Date"),
        dataIndex: "createdOn",
        key: "createdOn",
        width: "30%",
      },
      // {
      //   title: "Path",
      //   dataIndex: "filePath",
      //   key: "filePath",
      //   width: "40%",
      //   ...this.getColumnSearchProps("filePath")
      // },
      {
        title: i18next.t("Action"),
        dataIndex: "operation",
        render: (text, record) =>
          this.state.data.length >= 1
            ? this.renderActionDropdown(record)
            : null,
      },
    ];

    let { isFetching } = this.state;
    const { uploading, file } = this.state;
    const props = {
      showUploadList: false,

      beforeUpload: (file) => {
        this.setState((state) => ({
          file: file,
        }));
        return false;
      },
      file,
    };

    return (
      <Page>
        {isFetching ? (
          <Spin></Spin>
        ) : (
          <div>
            <Row style={{ marginTop: "25px" }}></Row>

            {/* <Upload {...props}>
              <Button
                style={
                  this.props.context.curr_dir === "ltr" &&
                  this.props.context.curr_lang === "en"
                    ? { marginRight: "20px", marginBottom: "25px" }
                    : { marginLeft: "20px", marginBottom: "25px" }
                }
              >
                <Icon type="upload" style={{ color: "" }} />
                {this.state.file === null
                  ? "Select File"
                  : this.state.file.name}
              </Button>
            </Upload> */}
            {/* {this.state.file === null ? null : (
              <Fragment>
                <Button
                  icon="delete"
                  className="button-delete"
                  onClick={this.hanndleCancel}
                  style={
                    this.props.context.curr_dir === "ltr" &&
                    this.props.context.curr_lang === "en"
                      ? { marginRight: "20px", marginBottom: "25px" }
                      : { marginLeft: "20px", marginBottom: "25px" }
                  }
                ></Button>

                <Button
                  type="primary"
                  onClick={this.handleUpload}
                  loading={uploading}
                >
                  {uploading ? "Uploading" : "Start Upload"}
                </Button>
              </Fragment>
            )} */}

            {this.state.edit ? (
              <CreateCallFlow
                callFlowData={this.state.callFlowData}
                back={() => {
                  this.setState({ edit: false });
                  this.setState({ callFlowData: undefined });
                }}
                recordData={this.state.recordData}
                history={this.props.history}
              ></CreateCallFlow>
            ) : (
              <>
                <Button
                  className="button-add-account"
                  onClick={this.addNewFlow}
                  icon="plus"
                />
                <span>{i18next.t("Add Call Flow")}</span>
                <Table
                  columns={columns}
                  bodyStyle={{
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                    borderRadius: "8px",
                    marginBottom: "25px",
                  }}
                  dataSource={this.state.data}
                  pagination={{
                    position: "bottom",
                    pageSize: 10,
                    itemRender: this.itemRender,
                  }}
                  bordered
                  locale={{
                    emptyText: (
                      <Empty
                        description={i18next.t("Empty")}
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                      />
                    ),
                  }}
                />
              </>
            )}
          </div>
        )}
      </Page>
    );
  }
}

export default withSharedStateConsumer(CallFlowsTable);
